"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var OnboardingStepIcon_1 = __importDefault(require("components/Icons/OnboardingStepIcon"));
var Body_1 = require("components/Text/Body");
var Accordion_1 = __importDefault(require("shared/components/Accordion"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var AccordionSummary_1 = __importDefault(require("shared/components/Accordion/AccordionSummary"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var StepTitle_1 = __importDefault(require("../styles/StepTitle"));
var MAPPER = {
    ACCEPTED: 'Yes, please',
    DEFERRED: 'Maybe later',
};
var RequestFullOnboarding = function (_a) {
    var isDone = _a.isDone;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _b = __read((0, hooks_1.useSubmitter)('users', profile.id), 2), usrSubmitter = _b[0], isSubmitting = _b[1];
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: "100%", mx: "auto" }, { children: (0, jsx_runtime_1.jsxs)(Accordion_1.default, __assign({ offsetHor: true, hideBorders: true }, { children: [(0, jsx_runtime_1.jsxs)(AccordionSummary_1.default, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mr: 4 }, { children: (0, jsx_runtime_1.jsx)(OnboardingStepIcon_1.default, { isDone: isDone }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(StepTitle_1.default, { children: "Onboard your own firm to Hudled" }) }))] }), (0, jsx_runtime_1.jsx)(AccordionDetails_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mr: 4, pl: 7 }, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["You\u2019ll be able to analyse and manage your own SaaS Stack, as well as running an audit on our tools and spend.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)(Body_1.Stronger, { children: ["Would you like to onboard ", company === null || company === void 0 ? void 0 : company.name, " to Hudled?"] })] }), profile.wantsToOnboardOwnFirm
                                ? (0, jsx_runtime_1.jsx)("p", { children: "Thanks! We\u2019ll be in touch soon." })
                                : ['ACCEPTED', 'DEFERRED'].map(function (wantsToOnboardOwnFirm) { return ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ sx: { m: 16, ml: 0 }, onClick: function () { return usrSubmitter({ wantsToOnboardOwnFirm: wantsToOnboardOwnFirm }); }, disabled: isSubmitting }, { children: MAPPER[wantsToOnboardOwnFirm] }), wantsToOnboardOwnFirm)); })] })) })] })) })));
};
exports.default = RequestFullOnboarding;
